import React from "react";

// Same markup as the pre-render splash in public/index.html, so route chunks load without a flash.
export default function Splash() {
  return (
    <div className="boot" role="status" aria-label="Loading LiteURL">
      <span className="boot__mark" />
    </div>
  );
}
